import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const IssueViewComments = lazyForPaint(
	() => import(/* webpackChunkName: "async-issue-view-comment" */ './index'),
);

export default IssueViewComments;
